import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=178fcbc0&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=178fcbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fcbc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178fcbc0')) {
      api.createRecord('178fcbc0', component.options)
    } else {
      api.reload('178fcbc0', component.options)
    }
    module.hot.accept("./Controls.vue?vue&type=template&id=178fcbc0&scoped=true&", function () {
      api.rerender('178fcbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Controls.vue"
export default component.exports